import { createBrowserLogger, type Logger } from '@repo/logger/browser';

/**
 * The web app's logger. Debug and up in dev, warn and up in production.
 *
 * The type is annotated rather than inferred: pnpm's isolated layout makes the
 * inferred pino type unnameable from here (TS2742).
 */
export const logger: Logger = createBrowserLogger({
  bindings: { component: 'web' },
  dev: import.meta.env.DEV,
});
